// javascript
// `crm/src/mixins/fadeTransition.js`
export default {
  methods: {
    fadeBeforeEnter(el) {
      el.style.opacity = '0';
      el.style.transition = 'opacity 200ms ease';
    },
    fadeEnter(el, done) {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });

      const onEnd = (e) => {
        if (e && e.target !== el) return;
        el.removeEventListener('transitionend', onEnd);
        el.style.transition = '';
        done && done();
      };
      el.addEventListener('transitionend', onEnd);
    },
    fadeAfterEnter(el) {
      el.style.opacity = '';
      el.style.transition = '';
    },
    fadeBeforeLeave(el) {
      el.style.opacity = '1';
      el.style.transition = 'opacity 200ms ease';
    },
    fadeLeave(el, done) {
      requestAnimationFrame(() => {
        el.style.opacity = '0';
      });

      const onEnd = (e) => {
        if (e && e.target !== el) return;
        el.removeEventListener('transitionend', onEnd);
        el.style.transition = '';
        done && done();
      };
      el.addEventListener('transitionend', onEnd);
    },
    fadeAfterLeave(el) {
      el.style.opacity = '';
      el.style.transition = '';
    }
  }
};
